export default {"src":"//_next/static/media/wheel.5ca8e7b3.svg","height":76,"width":76,"blurWidth":0,"blurHeight":0};